// extracted by mini-css-extract-plugin
module.exports = {"voucherText":"StudioVoucherText-module__voucherText___33OWh"};